'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var CfgManager = require('./config');
var configFilter = require('./util/filter');
var EM = require('./error/model');
var ErrManager = require('./error/manager');
var ResManager = require('./resource/manager');
var PageManager = require('./page/index');
var MetricManager = require('./metric/index');
var LogManager = require('./log/manager');
var Logan = require('./util/logan');

var catchError = require('./error/catch');
var catchResource = require('./resource/catch');
var catchPage = require('./page/catch');

var Dimns = require('./dimns');
var version = require('./constant/version').version;
var category = require('./constant/category');

var Logger = require('./util/logger');
var Global = require('./util/global');

/**
 * 监控类
 * 
 * @class OWL
 */

var OWL = function () {
    /**
     * Creates an instance of OWL.
     * @param {Object} config 
     * @param {Object} opts 
     * @memberof OWL
     */
    function OWL(config, opts) {
        _classCallCheck(this, OWL);

        var cfgManager = new CfgManager(config);
        this.errManager = new ErrManager(cfgManager, this);
        this.pageManager = new PageManager(cfgManager);
        this.resManager = new ResManager(cfgManager, this.errManager);
        this.metricManager = new MetricManager(cfgManager);
        this.logManager = new LogManager(cfgManager);
        this.cfgManager = cfgManager;

        this.init();
        if (!(opts && opts.noFilter)) {
            configFilter(this.cfgManager);
        }
    }

    _createClass(OWL, [{
        key: 'init',
        value: function init() {
            this.cfgManager.setExtension(Dimns.getExt());
        }
        /**
         * 配置相关参数
         * @param {Object} config 
         * @memberof OWL
         */

    }, {
        key: 'config',
        value: function config(_config) {
            this.cfgManager.set(_config);
        }
        /**
         *  记录JS错误
         *  @param {any} err - 错误信息
         *  @param {Object} opts - 可选配置
         *  @param {Boolean} opts.combo - 是否合并请求
         *  @param {string} opts.level - 错误级别
         *  @param {string} opts.category - 错误分类
         *  @param {Object} opts.tags - 其他用户自定义信息
         *  @memberof OWL
         */

    }, {
        key: 'addError',
        value: function addError(err, opts) {
            if (opts && opts.combo === false) {
                this.errManager.report(err, opts);
            } else if (this.cfgManager.get('error').combo === false) {
                this.errManager.report(err, opts);
            } else {
                this.errManager.push(err, opts);
            }
        }
        /**
         *  手动上报所有缓存错误
         *  @memberof OWL
         */

    }, {
        key: 'sendErrors',
        value: function sendErrors() {
            this.errManager.report();
        }
        /**
         * 添加自定义页面性能点
         *  @param {Object} point - 性能点对象
         *  @param {Number} point.position - 性能点位置
         *  @param {Number} point.duration - 时间间隔
         *  @param {Number} point.timeStamp - 当前时间戳
         *  @memberof OWL
         */

    }, {
        key: 'addPoint',
        value: function addPoint() {
            var point = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

            var _pageManager$getPerfo = this.pageManager.getPerformaceTiming(),
                perf = _pageManager$getPerfo.perf;

            var newPoint = void 0;

            if (point.duration !== undefined) {
                newPoint = point;
            } else {
                if (perf !== undefined) {
                    var ts = point.timeStamp || +new Date();

                    newPoint = {
                        position: point.position,
                        duration: ts - perf.navigationStart
                    };
                }
            }

            if (newPoint) {
                this.pageManager.setUserReady();
                this.pageManager.push(newPoint);
                this.pageManager.report();
            }
        }
        /**
         * 手动上报页面性能点
         * @memberof OWL
         */

    }, {
        key: 'sendPoints',
        value: function sendPoints() {
            this.pageManager.report(true);
        }
        /**
         *  手动上报接口信息
         *  @param {Object} api - 接口信息
         *  @param {string} api.name - 接口名称
         *  @param {Number} api.networkCode - 网络状态码
         *  @param {Number} api.statusCode - 接口状态码
         *  @param {Number} api.responsetime - 接口延时
         *  @param {string} [api.content] - 接口错误详情
         *  @memberof OWL
         */

    }, {
        key: 'addApi',
        value: function addApi(api) {
            if (!api) return;
            if (api.networkCode !== undefined && typeof api.networkCode !== 'number') return Logger.ignore('网络状态码必须为Number类型', JSON.stringify(api));
            if (api.statusCode !== undefined && typeof api.statusCode !== 'number') return Logger.ignore('业务状态码必须为Number类型', JSON.stringify(api));
            var newApi = {
                type: 'api',
                resourceUrl: api.name,
                statusCode: (api.networkCode || '') + '|' + (api.statusCode || ''),
                responsetime: api.responseTime
            };
            if (api.content) {
                newApi.firstCategory = category.AJAX;
                newApi.secondCategory = api.secondCategory || api.name;
                newApi.logContent = api.content;
            }
            this.resManager.pushApi(newApi);
        }
        /**
         * @deprecated
         */

    }, {
        key: 'reportApi',
        value: function reportApi() {
            this.addApi.apply(this, arguments);
        }
        /**
         * 上报API接口采集数据
         * 
         * @memberof OWL
         */

    }, {
        key: 'sendApis',
        value: function sendApis() {
            this.resManager.report();
        }
        /**
         * 上报日志
         */

    }, {
        key: 'addLog',
        value: function addLog(message) {
            this.logManager.addLog(message);
        }
        /**
         * @deprecated
         */

    }, {
        key: 'createLog',
        value: function createLog() {
            var cfgManager = this.cfgManager;
            var logInstance = new LogManager(cfgManager);
            return logInstance;
        }
        /**
         * 更新错误过滤
         * 
         * @param {string} key - 过滤器名称
         * @param {Function} fn - 过滤器函数
         * @memberof OWL
         */

    }, {
        key: 'updateFilter',
        value: function updateFilter(key, fn) {
            if (fn === undefined) {
                this.cfgManager.removeFilter(key);
            } else {
                this.cfgManager.addFilter(key, fn);
            }
        }
        /**
         * 为函数提供try-catch封装，避免错误抛到window上
         * 
         * @param {Function} func - 需要封装的函数
         * @param {Object} context - 函数执行的上下文环境
         * @param {Object} opts - 针对错误的封装，等同于addError API中的opts 
         */

    }, {
        key: 'wrap',
        value: function wrap(func, context, opts) {
            if (typeof func !== 'function') {
                return func;
            }

            try {
                if (func.__owl_wrapped__) {
                    return func;
                }
                if (func.__owl_wrapper__) {
                    return func.__owl_wrapper__;
                }
            } catch (e) {
                return func;
            }

            var wrapped = function wrapped() {
                try {
                    return func.apply(context, arguments);
                } catch (e) {
                    Owl.addError(e, opts);
                }
            };

            for (var property in func) {
                if (func.prototype.hasOwnProperty(property)) {
                    wrapped[property] = func[property];
                }
            }

            wrapped.prototype = func.prototype;

            func.__owl_wrapper__ = wrapped;

            wrapped.__owl_wrapper__ = true;

            return wrapped;
        }
        /**
         * 设置维度信息，支持'region', 'operator', 'network', 'container', 'os', 'latlng'
         * 当key为latlng时,值必须为'${lat},${lng}'格式，比如'121.426805,31.221485'
         * 
         */

    }, {
        key: 'setDimension',
        value: function setDimension(object) {
            this.cfgManager.setExtension(object);
        }
    }]);

    return OWL;
}();

var Owl = new OWL({}, {
    noFilter: true
});

Owl.OWL = OWL;
Owl.__version__ = version;
Owl.errorModel = EM;
Owl.MetricManager = MetricManager;

/**
 * 启动监控上报
 * 
 * @param {object} configs - 相关配置信息
 */
Owl.start = function (configs) {

    var userAgent = Global.getUserAgent();
    if (userAgent.indexOf('Baiduspider') !== -1) {
        return Logger.ignore('当前环境被判断为百度爬虫，监控功能关闭');
    }

    //只启动一次
    if (this.isStarted) return;
    this.isStarted = true;

    //设置默认页面地址
    Owl.cfgManager.set({
        pageUrl: Global.getHref()
    });
    if (configs) {
        //  修复resource.sample可以配置的遗留问题
        if (configs && configs.resource && configs.resource.sample) {
            configs.resource.sample = undefined;
        }
        Owl.cfgManager.set(configs);

        Owl.cfgManager.checkUpdate();
    }
    if (this.cfgManager.get('logan').enable) {
        var LoganAPI = this.cfgManager.get('logan').Logan;
        var project = this.cfgManager.get('project');
        var pageUrl = this.cfgManager.get('pageUrl');
        Logan.ready({
            LoganAPI: LoganAPI,
            project: project,
            pageUrl: pageUrl
        });
    }

    configFilter(Owl.cfgManager);

    catchPage(Owl.pageManager);
    catchError(Owl.errManager);
    catchResource(Owl.resManager, Owl.errManager);

    var preLoadName = configs.preLoadName || '_Owl_';

    if (window[preLoadName]) {

        //禁止loader的采集
        window[preLoadName].isReady = true;

        var _window$preLoadName = window[preLoadName],
            config = _window$preLoadName.config,
            preTasks = _window$preLoadName.preTasks,
            dataSet = _window$preLoadName.dataSet;


        Owl.cfgManager.set({
            autoCatch: config
        });

        if (preTasks && preTasks.length) {
            preTasks.forEach(function (task) {
                //api调用必须同步执行
                Owl[task.api].apply(Owl, task.data);
            });
            window[preLoadName].preTasks = [];
        }

        setTimeout(function () {
            //数据上报异步执行
            if (dataSet && dataSet.length) {
                dataSet.forEach(function (dataItem) {
                    if (dataItem && dataItem.type === 'jsError') {
                        Owl.errManager.parseWindowError.apply(Owl.errManager, dataItem.data);
                    } else if (dataItem.type === 'resError') {
                        Owl.resManager.handleResourceLoadError.apply(Owl.resManager, dataItem.data);
                    } else if (dataItem.type === 'resTime') {
                        Owl.resManager.handleResourceTiming.apply(Owl.resManager, dataItem.data);
                    } else if (dataItem.type === 'pageTime') {
                        Owl.pageManager.parsePageTime.apply(Owl.pageManager, dataItem.data);
                    }
                });
            }
            window[preLoadName].dataSet = [];
        }, 0);
    }

    var isSPA = Owl.cfgManager.get('isSPA');
    if (isSPA) {
        var originOnpopstate = window.onpopstate;
        window.onpopstate = function (event) {
            Owl.cfgManager.set({
                pageUrl: Global.getHref()
            });
            var onpopstate = Owl.cfgManager.get('onpopstate');
            try {
                onpopstate(event);
            } catch (e) {
                Logger.ignore(e);
            }
            originOnpopstate && originOnpopstate.apply(window, event);
        };
    }

    Owl.errManager.checkCache();

    var versionReport = require('./version');
    versionReport('owl_sdk', Owl);
};

module.exports = Owl;


//////////////////
// WEBPACK FOOTER
// ./~/@dp/owl/lib/index.js
// module id = 152
// module chunks = 0